import React from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import { Grid, SearchSelect, makeStyles, DatePicker, CreatableSelect } from "../../../..";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    info: {
      display: "flex",
      "justify-content": "flex-start",
      padding: "15px 0px 70px",
      "align-items": "baseline"
    },
    client: {
      "min-width": "30%"
    },
    mr15: {
      "margin-right": "15px"
    },
    minw10: {
      "min-width": "10%"
    }
  };
});

var DocumentInfo = function DocumentInfo(props) {
  var mode = props.mode,
      translation = props.translation,
      type = props.type,
      clients = props.clients,
      values = props.values,
      series = props.series,
      franchise = props.franchise,
      handleCreateClient = props.handleCreateClient,
      createBillingInfo = props.createBillingInfo; //   console.log("Documentinfo props", props);

  var classes = useStyles();
  return [/*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.info
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "client",
    name: type === "out" ? "client" : "franchise",
    component: franchise ? CreatableSelect : SearchSelect,
    placeholder: translation ? translation.selects.client.placeholder : "Client",
    className: [classes.mr15, classes.client].join(" "),
    options: clients,
    clickable: mode !== "view",
    handleCreate: handleCreateClient,
    variant: "billing",
    createBillingInfo: createBillingInfo
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "serie_id",
    name: "serie_id",
    component: SearchSelect,
    placeholder: translation ? translation.selects.series.placeholder : "Serie",
    className: [classes.minw10, classes.mr15].join(" "),
    options: series,
    clickable: mode !== "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "docnumber",
    name: "docnumber",
    component: TextField,
    className: classes.mr15,
    value: values.docnumber,
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "date",
    name: "date",
    className: classes.mr15,
    label: translation ? translation.inputs.date : "Date",
    component: DatePicker,
    value: values.date,
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "due_date",
    name: "due_date",
    className: classes.mr15,
    label: translation ? translation.inputs.due_date : "Due date",
    component: DatePicker,
    value: values.due_date,
    disabled: mode === "view"
  }))];
};

export { DocumentInfo };